// extracted by mini-css-extract-plugin
export default {"parentDiv":"Login_parentDiv__wR4xm","heading":"Login_heading__zhRhM","textContent":"Login_textContent__RTPKc"};